import { useMemo, useState } from "react";
import { getPlayerIconById } from "../../lib/playerIcons";

interface VotingPanelProps {
	roomId: string;
	players: { id: string; name: string; iconId?: number }[];
	myPlayerId: string;
	currentDeck: string;
	spyAssetName: string;
	onVote?: (targetId: string) => void;
	counts?: Record<string, number>;
	voters?: string[];
	onVotingComplete?: (result: { accusedId: string | null; isSpy: boolean }) => void;
}

export default function VotingPanel({ roomId, players, myPlayerId, currentDeck, spyAssetName, onVote, counts = {}, voters = [], onVotingComplete }: VotingPanelProps) {
	const [myChoice, setMyChoice] = useState<string | null>(null);
	const total = players.length;

	const hasVoted = useMemo(() => voters.includes(myPlayerId) || !!myChoice, [voters, myPlayerId, myChoice]);

	const handleClick = (targetId: string) => {
		setMyChoice(targetId);
		if (onVote) onVote(targetId);
	};

	return (
		<div className="w-full">
            <div className="text-center text-gray-300 mb-4">
					Pick who you think is the {spyAssetName}. The {spyAssetName} is caught if they have majority votes. (All votes must be cast to end voting)
            </div>
			<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
				{players.map((p) => {
					const votedCount = counts[p.id] || 0;
					const isMine = myChoice === p.id;
					return (
						<button
							key={p.id}
							onClick={() => handleClick(p.id)}
							className={`relative w-full px-4 py-3 rounded-md border ${isMine ? 'border-red-500 bg-red-900/30' : 'border-gray-700 bg-gray-800 hover:bg-gray-700'} text-left transition-colors`}
						>
							<span className="flex items-center gap-3">
								<span className="flex-shrink-0 w-7 h-7 bg-gray-700 rounded-full flex items-center justify-center overflow-hidden">
									<span
										className="w-5 h-5"
										dangerouslySetInnerHTML={{ __html: getPlayerIconById(p.iconId ?? 0).svg }}
									/>
								</span>
								<span className="font-medium">{p.name}</span>
							</span>
							{votedCount > 0 && (
								<span className="absolute right-3 top-1/2 -translate-y-1/2 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded-full">
									{votedCount}
								</span>
							)}
						</button>
					);
				})}
			</div>
			<div className="text-center text-sm text-gray-400 mt-3">
				Votes: {voters.length}/{total} {hasVoted ? '(your vote is in)' : ''}
			</div>
		</div>
	);
}


